module.exports = __webpack_public_path__ + "img/160.a454e6dd.jpg";